import { GTM_ERROR_CODES } from '../error-codes';
import { Repository } from '../utils/Repository';

(() => {
    document.addEventListener('ProductShow_Variant_PostLoad', (e) => {
        const { variant } = e.detail;

        //---------------------------------------------------------------------------
        // "view_item" en la carga de una variante
        //---------------------------------------------------------------------------

        const viewItemEventDatasetId = `gtm-view-item-${variant.code}`;
        const viewItemEventDataset = document.getElementById(viewItemEventDatasetId);
        const viewItemEvent = JSON.parse(viewItemEventDataset.dataset.gtmJson);

        new Repository().addToItemsSelected(viewItemEvent.ecommerce.items[0]);

        window.dataLayerPushDeferred({ ecommerce: null });
        window.dataLayerPushDeferred(viewItemEvent);

        //---------------------------------------------------------------------------
        // "view_item_list" de venta cruzada en la carga de una variante
        //---------------------------------------------------------------------------

        const viewCrossSellItemListDatasets = document.querySelectorAll(`.gtm-view-item-list-cross-selling[data-variant-code="${variant.code}"]`);
        viewCrossSellItemListDatasets.forEach((viewItemListCrossSellingDataset) => {
            window.dataLayerPushDeferred({ ecommerce: null });
            window.dataLayerPushDeferred(JSON.parse(viewItemListCrossSellingDataset.dataset.gtmJson));
        });

        //---------------------------------------------------------------------------
        // "error" al cargar variante sin stock
        //---------------------------------------------------------------------------

        if (!variant.isSellable) {
            window.dataLayerPushDeferred({
                event: 'error',
                error_id: GTM_ERROR_CODES.INFO_VARIANT_NO_STOCK,
            });
        }
    });

    //---------------------------------------------------------------------------
    // "add_to_cart" en click de botón
    //---------------------------------------------------------------------------

    document.addEventListener('ProductShow_AddToCart_Click', (e) => {
        const addToCartDatasetId = 'gtm-add-to-cart';
        const addToCartDataset = document.getElementById(addToCartDatasetId);
        const addToCart = JSON.parse(addToCartDataset.dataset.gtmJson);

        const itemDatasetId = `gtm-item-${e.detail.variant.code}`;
        const itemDataset = document.getElementById(itemDatasetId);
        const item = JSON.parse(itemDataset.dataset.gtmJson);

        const quantity = parseInt(e.detail.quantity);

        addToCart.value = e.detail.total / 100;
        item.quantity = quantity;
        addToCart.ecommerce.items.push(item);

        if (e.detail.crossSellSelectionByProviderCode) {
            let variantCodes = [];
            Object.keys(e.detail.crossSellSelectionByProviderCode).forEach((providerCode) => {
                Object.keys(e.detail.crossSellSelectionByProviderCode[providerCode]).forEach((variantCode) => {
                    variantCodes.push(variantCode);
                });
            });

            if (variantCodes.length > 0) {
                const analyticsRepository = new Repository();

                variantCodes.forEach((variantCode) => {
                    const crossSellingItemDatasetId = `gtm-item-${variantCode}`;
                    const crossSellingItemDataset = document.getElementById(crossSellingItemDatasetId);
                    const crossSellingItemStock = parseInt(crossSellingItemDataset.dataset.stock);
                    const crossSellingItem = JSON.parse(crossSellingItemDataset.dataset.gtmJson);
                    crossSellingItem.quantity = quantity > crossSellingItemStock ? crossSellingItemStock : quantity;
                    addToCart.ecommerce.items.push(crossSellingItem);
                    analyticsRepository.addToItemsSelected(crossSellingItem);
                });
            }
        }

        window.dataLayerPushDeferred({ ecommerce: null });
        window.dataLayerPushDeferred(addToCart);
    });

    //---------------------------------------------------------------------------
    // "stock_notification" submit form
    //---------------------------------------------------------------------------

    document.addEventListener('ProductShow_StockNotificationForm_Submit', (e) => {
        window.dataLayerPushDeferred({
            event: 'generate_lead',
            event_type: 'alta_stock',
            currency: 'EUR',
            value: e.detail.price,
        });
    });

    //---------------------------------------------------------------------------
    // "view_item_list" al cargar cross sell modal
    //---------------------------------------------------------------------------

    document.addEventListener('CrossSellModal_Show', (e) => {
        const { variant } = e.detail;

        const viewItemListCrossSellingModalDatasetId = `gtm-view-item-list-cross-selling-modal-${variant.code}`;
        const viewItemListCrossSellingModalDataset = document.getElementById(viewItemListCrossSellingModalDatasetId);

        if (viewItemListCrossSellingModalDataset) {
            const viewItemListEvent = JSON.parse(viewItemListCrossSellingModalDataset.dataset.gtmJson);

            window.dataLayerPushDeferred({ ecommerce: null });
            window.dataLayerPushDeferred(viewItemListEvent);

            new Repository().addItemsToCartModal(viewItemListEvent.ecommerce.items);
        }
    });

    //---------------------------------------------------------------------------
    // "select_item" en cross sell modal
    //---------------------------------------------------------------------------

    document.addEventListener('CrossSellModal_Card_Click', (e) => {
        const datasetId = document.getElementById(`gtm-select-item-cross-selling-modal-${e.detail}`);
        const selectItemEvent = JSON.parse(datasetId.dataset.gtmJson);

        window.dataLayerPushDeferred({ ecommerce: null });
        window.dataLayerPushDeferred(selectItemEvent);
    });

    //---------------------------------------------------------------------------
    // "add_to_cart" en cross sell modal
    //---------------------------------------------------------------------------

    document.addEventListener('CrossSellModal_AddToCart', (e) => {
        const addToCartDatasetId = 'gtm-add-to-cart';
        const addToCartDataset = document.getElementById(addToCartDatasetId);
        const addToCart = JSON.parse(addToCartDataset.dataset.gtmJson);

        const itemDatasetId = `gtm-cart-item-cross-selling-modal-${e.detail.variantCode}`;
        const itemDataset = document.getElementById(itemDatasetId);
        const item = JSON.parse(itemDataset.dataset.gtmJson);

        item.quantity = parseInt(e.detail.quantity);
        addToCart.ecommerce.items.push(item);

        window.dataLayerPushDeferred({ ecommerce: null });
        window.dataLayerPushDeferred(addToCart);
    });

    //---------------------------------------------------------------------------
    // "remove_from_cart" en cross sell modal
    //---------------------------------------------------------------------------

    document.addEventListener('CrossSellModal_RemoveFromCart', (e) => {
        const removeFromCartDatasetId = 'gtm-remove-from-cart';
        const removeFromCartDataset = document.getElementById(removeFromCartDatasetId);
        const removeFromCart = JSON.parse(removeFromCartDataset.dataset.gtmJson);

        const itemDatasetId = `gtm-cart-item-cross-selling-modal-${e.detail.variantCode}`;
        const itemDataset = document.getElementById(itemDatasetId);
        const item = JSON.parse(itemDataset.dataset.gtmJson);

        item.quantity = parseInt(e.detail.quantity);
        removeFromCart.ecommerce.items.push(item);

        window.dataLayerPushDeferred({ ecommerce: null });
        window.dataLayerPushDeferred(removeFromCart);
    });

    //---------------------------------------------------------------------------
    // "close_modal" al cerrar cross sell modal
    //---------------------------------------------------------------------------

    document.addEventListener('CrossSellModal_Close', (e) => {
        window.dataLayerPushDeferred({
            event: 'close_modal',
            event_type: e.detail,
        });
    });

    //---------------------------------------------------------------------------
    // "error" al aumentar cantidad de variante
    //---------------------------------------------------------------------------

    document.addEventListener('ProductShow_IncreaseQuantity_Click', (e) => {
        const { variant } = e.detail;
        const { quantity } = e.detail;

        if (!variant.isSellable || (variant.isTracked && quantity >= variant.stock)) {
            window.dataLayerPushDeferred({
                event: 'error',
                error_id: GTM_ERROR_CODES.WARNING_VARIANT_MAX_STOCK_REACHED,
            });
        }
    });

    //---------------------------------------------------------------------------
    // "error" al agregar al carrito una variante sin stock
    //---------------------------------------------------------------------------

    document.addEventListener('ProductShow_AddToCart_Error', () => {
        window.dataLayerPushDeferred({
            event: 'error',
            error_id: GTM_ERROR_CODES.ERROR_FORM_NOT_ENOUGH_STOCK,
        });
    });
})();
